<template>
  <div>
    <div class="v-messages theme--light error--text ml-3" role="alert">
      <div class="v-messages__wrapper">
        <div class="v-messages__message">{{message}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["message"],
};
</script>